import ThemedLayout from 'components/atoms/ThemedLayout'
import i18n from 'utils/i18n'
import ThemedSafeAreaComponentTop from 'components/atoms/ThemedSafeAreaTop'
import React, { useEffect, useState } from 'react'
import { useShowHamburger } from 'utils/helper-device'
import { constantsActive } from 'utils/constants/constants'
import ManagementGroupedThemeList from 'components/management/molecules/ManagementGroupedThemeList'
import HelperManagementRights from 'utils/helper-management-rights'
import { managementRightsConstants } from 'utils/constants/management-right-constants'
import ManagementHeader from 'components/management/molecules/ManagementHeader'
import ListItem from 'components/atoms/ListItem'
import { listArrow } from 'styles/list'
import { useIsFocused, useNavigation } from '@react-navigation/native'
import FetchManagementEmails from 'utils/fetch/management/FetchManagementEmails'
import { AppRoutes } from 'navigations/app-routes'
import FetchAppMessages from 'utils/fetch/FetchAppMessages'
import Translate from 'utils/translate'
import HelperDate from 'utils/helper-date'

const ManagementAppMessagesIndexScene = () => {
	
	const navigation = useNavigation();
	const isFocused = useIsFocused();
	const showHamburger = useShowHamburger();
	
	const [ loading, setLoading ] = useState( true )
	const [ appMessages, setAppMessages ] = useState( [] )
	
	const fetchAppMessages = () => {
		FetchAppMessages.fetchAll({
			callbackStart: setLoading.bind( this, true ),
			callbackError: setLoading.bind( this, false ),
			callbackSuccess: items => {
				setLoading.bind( this, false )
				
				setAppMessages( items )
			},
		})
	}
	
	const onPressCreateAppMessage = () => {
		onPress( {} );
	}
	
	const onPress = ( item ) => {
		navigation.navigate( AppRoutes.MANAGEMENT_APP_MESSAGES_EDIT, {
			guid: item.guid
		} );
	}
	
	const renderItem = ( { item, index } ) => {
		
		const dateStartEnd = item.date_start +' - '+ item.date_end;
		
		return (
			<ListItem
				title={ Translate.field( item, 'title' ) }
				//subtitle={ Translate.field( item, 'description' ) }
				subtitle={ dateStartEnd }
				title_add_active_tag={ true }
				item={ item }
				accessoryRight={ listArrow }
				onPress={ onPress }
			/>
		)
	}
	
	useEffect( () => {
		return fetchAppMessages();
	}, [ isFocused ] )
	
	return (
		<ThemedSafeAreaComponentTop
			top={ false }>
			
			<ThemedLayout
				title={i18n.t('management:pages.app_messages.index.title')}
				topNavigation={true}
				topNavigationProps={{
					showHamburgerDrawer: showHamburger
				}}>
				
				<ManagementGroupedThemeList
					header={(
						<ManagementHeader
							inputs={[
								{
									placeholder: i18n.t( 'management:pages.emails.index.input_search'),
									//onChangeText: _.debounce( setSearch, 400 )
								}
							]}
							addButton={ HelperManagementRights.hasEditRight( managementRightsConstants.EDIT.SETTINGS ) ? { onPress: onPressCreateAppMessage } : null }
						/>
					)}
					items={ appMessages }
					renderItem={ renderItem.bind( this ) }
					groupByKey={ 'active' }
					//filters={ filters }
					groupByValues={ [
						constantsActive.YES,
						constantsActive.NO
					] }
				/>
			</ThemedLayout>
		</ThemedSafeAreaComponentTop>
	)
}

export default ManagementAppMessagesIndexScene
